import { PageHeader, cn } from '@sitewise/ui';
import { useQuery } from '@tanstack/react-query';
import { NavLink, Outlet } from 'react-router-dom';


import { fetchMe } from '../../../api/auth.js';

interface NavItem {
  to: string;
  label: string;
  adminOnly?: boolean;
}

const ITEMS: NavItem[] = [
  { to: '/settings/profile', label: 'Profile' },
  { to: '/settings/security', label: 'Security' },
  { to: '/settings/notifications', label: 'Notifications' },
  { to: '/settings/branding', label: 'Branding', adminOnly: true },
  { to: '/settings/users', label: 'Users', adminOnly: true },
  { to: '/settings/teams', label: 'Teams', adminOnly: true },
  { to: '/settings/work-orders', label: 'Work orders', adminOnly: true },
  { to: '/settings/unit-fields', label: 'Unit fields', adminOnly: true },
  { to: '/settings/violations', label: 'Violations', adminOnly: true },
  { to: '/settings/vendors', label: 'Vendors', adminOnly: true },
  { to: '/settings/ai', label: 'AI assistant', adminOnly: true },
  { to: '/settings/display', label: 'Display', adminOnly: true },
  { to: '/compliance/device-types', label: 'Compliance module', adminOnly: true },
  { to: '/inspections/templates', label: 'Inspection templates', adminOnly: true },
];

export function SettingsLayout() {
  const meQuery = useQuery({ queryKey: ['me'], queryFn: fetchMe });
  const isAdmin = meQuery.data?.user.role === 'admin';
  const visible = ITEMS.filter((item) => !item.adminOnly || isAdmin);

  return (
    <>
      <PageHeader title="Settings" description="Manage your profile, security, and organization." />
      <div className="grid gap-6 md:grid-cols-[180px_1fr]">
        <nav>
          <ul className="space-y-0.5">
            {visible.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    cn(
                      'block rounded px-3 py-1.5 text-sm font-medium',
                      isActive
                        ? 'bg-primary-subtle text-primary'
                        : 'text-fg-secondary hover:bg-surface-muted hover:text-fg',
                    )
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <Outlet />
        </div>
      </div>
    </>
  );
}
